const CDN_BASE = 'https://cdn.blisspointmedia.com/demoData';

// AMC endpoint (amc lambda) serving live market-basket cross-sell pathing rows.
export const CATEGORY_PATHING_ENDPOINT = '/getCategoryPathingReport';

// ASIN → (product name, category) mapping stays a per-client CSV, ingested by DEV-23308
// (e.g. `olly-product-segments.csv`). The live endpoint provides the pathing rows.
export const mappingCsvUrl = (cid: string): string => `${CDN_BASE}/${cid}-product-segments.csv`;

// Static demo dataset (Olly), served purely from CDN CSVs — no backend. Powers the hidden
// `commerce/amc-experiment` comparison route so the live version can be compared against the
// known-good demo. `categoryAll` is a dedicated category-level file (the live version derives
// category rows from the ASIN rows instead).
export const DEMO_CSV_PATHS = {
  asin: `${CDN_BASE}/amc-1682-olly-pathing-asin.csv`,
  categoryAll: `${CDN_BASE}/amc-1682-olly-pathing-category.csv`,
  mapping: `${CDN_BASE}/olly-product-segments.csv`
} as const;

export const DEMO_REPORT_WINDOW_LABEL = 'Jun 2025 – May 2026';

export const ValueMode = {
  COUNT: 'count',
  PERCENT: 'percent'
} as const;
export type ValueModeType = (typeof ValueMode)[keyof typeof ValueMode];
